import React, { useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { useAuth } from "../utilities/auth";
import { canAccessPath, firstAllowedPath } from "../utilities/adminAccess";
import SideBar from "../components/SideBar";
import AdminHeader from "../components/AdminHeader"
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {logOut, removeRefreshToken} from '../actions/usersActions'
import {API_URLS} from '../constants/config'


function PrivateRoute({ component: Component, ...rest }) {
  const { userData, setUserData } = useAuth();
  const hasAccess = (pathname) => Boolean(userData) && canAccessPath(userData, pathname);
  const [isBarCollapsed, setIsBarCollapsed] = useState(true);
  const [dropDownVisible, setDropDownVisible] = useState(false);

  const logOut = () => {
    rest.actions.removeRefreshToken(API_URLS.logout);
    rest.actions.logOut();
    setUserData();
  }

  const toggleBar = () => {
    setIsBarCollapsed(!isBarCollapsed)
  }

  const toggleDropDown = () => {
    setDropDownVisible(!dropDownVisible)
  }

  const closeDropDown = () => {
    setDropDownVisible(false)
  }

  const onNavigate = () => {
    setIsBarCollapsed(true);
    setDropDownVisible(false);
  }

  return (
    <Route
      {...rest}
      render={props =>
        userData && hasAccess(props.location.pathname) ? (
          <div className={`adminPage${isBarCollapsed ? '' : ' is-sidebar-open'}`}>
          <SideBar collapsed={isBarCollapsed} onNavigate={onNavigate}/>
          {isBarCollapsed ? null : (
            <button
              type="button"
              className="sidebarBackdrop"
              onClick={toggleBar}
              aria-label="Close menu"
            />
          )}
          <div className="adminMain">
            <AdminHeader 
              logOut={logOut}
              onEditAccount={onNavigate}
              toggleDropDown={toggleDropDown}
              closeDropDown={closeDropDown}
              dropDownVisible={dropDownVisible} 
              userData={userData} 
              toggleSideBar={toggleBar}/>
              <div className="pageWrapper">
          <Component {...props} />
          </div>
          </div>
          </div>
        ) : (
          <Redirect
          to={{ pathname: userData ? firstAllowedPath(userData) : "/", state: { referer: props.location } }}
        />
        )
      }
    />
  );
}

const mapStateToProps = state => ({
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({logOut, removeRefreshToken}, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrivateRoute);
